import { LandingContent } from "./types";

export const annualSummitLanding: LandingContent = {
  ctaText: "Request the agenda",
  quickFacts: ["Member discount", "Family-friendly", "Recorded sessions"],
  whyHeading: "Why teams use Annual Summit",
  why: "The Summit is where coaching relationships turn into lifelong networks. Three days in a destination city, 40+ breakout sessions, 1:1 time with your coach, and an awards ceremony that celebrates the year's top performers. Attendance averages 1,400+ owners and key staff — most members say it's the single most valuable event of their year.",
  advantages: [
    {
      title: "40+ breakouts across 4 tracks",
      description:
        "Owners, managers, marketers, and technical leaders — plus a dedicated spouse/partner track.",
      includedNote: "3 days, 40+ breakout sessions",
    },
    {
      title: "1:1 coach time",
      description:
        "Dedicated time with your CertainPath coach, scheduled in advance — not a hallway hello.",
      includedNote: "1:1 coach time",
    },
    {
      title: "Awards & recognition",
      description:
        "An evening celebration of the year's top performers across categories like growth, retention, and culture.",
      includedNote: "Awards ceremony",
    },
  ],
  featureChecklist: [
    "3 days, 40+ breakout sessions",
    "1:1 coach time",
    "Awards ceremony",
    "Vendor & software showcase",
  ],
  highlights: [],
  steps: [
    {
      title: "Reserve your seats",
      description:
        "Open registration with your member discount. Most owners bring 2-4 key staff for alignment.",
    },
    {
      title: "Build your agenda",
      description:
        "Pick from 40+ breakouts across 4 tracks. Your coach helps prioritize what's most relevant for your stage.",
    },
    {
      title: "Three days on-site",
      description:
        "Keynotes, breakouts, peer roundtables, vendor showcase, and the awards evening.",
    },
    {
      title: "Bring it home",
      description:
        "Post-summit playbooks and recordings keep the work alive when you're back in your shop.",
    },
  ],
  testimonials: [],
  faqs: [
    {
      question: "When is the next Summit?",
      answer:
        "Dates and location are announced 6 months ahead. Members get first access via the registration portal.",
    },
    {
      question: "Should I bring my team?",
      answer:
        "Most owners bring 2-4 key staff. The shared experience and dedicated tracks for managers and partners pay back many times over.",
    },
    {
      question: "What if I can't make all three days?",
      answer:
        "Single-day passes are available, but most members say the second-day evening is when the real connections happen.",
    },
  ],
  closing: {
    heading: "Reserve your Summit seats",
    body: "Three days that pay back for the rest of the year. Request the agenda or reserve your seats now.",
  },
};
